import Label from './Label.styled'
export default Label
